document.addEventListener('DOMContentLoaded', () => {
  const formDiv = document.getElementById('store_groups_form');
  if (formDiv == null) {
    return;
  }
  const brandCheckboxes = document.querySelectorAll('.brand-checkbox');
  const prefectureCheckboxes = document.querySelectorAll('.prefecture-checkbox');
  const storeCheckboxes = document.querySelectorAll('.store-checkbox');
  const storeNameInput = document.getElementById('store_name') as HTMLInputElement;

  const refreshStoreCount = () => {
    var count = 0;
    storeCheckboxes.forEach(checkbox => {
      const checked = (checkbox as HTMLInputElement).checked;
      if (checked) {
        count += 1;
      }
    });
    const selectedStoresCount =  document.querySelector('.selected-stores-count') as HTMLElement;
    selectedStoresCount.innerText = count + '件を選択中';
  }

  brandCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const brandId = (checkbox as HTMLInputElement).value;
      const checked = (checkbox as HTMLInputElement).checked;
      const checkboxOfBrand = document.querySelectorAll('.store-checkbox-of-brand-' + brandId);
      checkboxOfBrand.forEach(cop => {
        const label = (cop as HTMLElement).parentElement as HTMLElement;
        if (label.style.display != 'none') {
          (cop as HTMLInputElement).checked = checked;
        }
      });
      // カウントを更新
      refreshStoreCount();
    });
  });

  prefectureCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const label = (checkbox as HTMLElement).parentElement;
      const prefectureDiv = (label as HTMLElement).parentElement;
      const prefectureId = (checkbox as HTMLInputElement).value;
      const checked = (checkbox as HTMLInputElement).checked;
      const checkboxOfPrefecture = (prefectureDiv as HTMLElement).querySelectorAll(
        '.store-checkbox-of-prefecture-' + prefectureId,
      );
      checkboxOfPrefecture.forEach(cop => {
        const label = (cop as HTMLElement).parentElement as HTMLElement;
        if (label.style.display != 'none') {
          (cop as HTMLInputElement).checked = checked;
        }
      });
      // カウントを更新
      refreshStoreCount();
    });
  });

  storeCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      // カウントを更新
      refreshStoreCount();
    });
  });

  storeNameInput.addEventListener('keyup', () => {
    const value = storeNameInput.value;
    if (value.length) {
      toggleStoreCheckboxes(value);
    } else {
      storeCheckboxes.forEach(checkbox => {
        const label = (checkbox as HTMLElement).parentElement as HTMLElement;
        label.style.display = 'inline-block';
      });
      refreshPrefectureDiv();
    }
  });

  const toggleStoreCheckboxes = (value: string) => {
    storeCheckboxes.forEach(checkbox => {
      const label = (checkbox as HTMLElement).parentElement as HTMLElement;
      const storeCode = (checkbox as HTMLElement).dataset.storeCode || '';
      const storeName = (checkbox as HTMLElement).dataset.storeName || '';
      if (storeCode.indexOf(value) != -1 || storeName.indexOf(value) != -1) {
        label.style.display = 'inline-block';
      } else {
        label.style.display = 'none';
      }
    });
    refreshPrefectureDiv();
  }

  const refreshPrefectureDiv = () => {
    // 都道府県のレイヤーで調整する
    prefectureCheckboxes.forEach(checkbox => {
      const label = (checkbox as HTMLElement).parentElement as HTMLElement;
      const prefectureDiv = (label as HTMLElement).parentElement as HTMLElement;
      const prefectureName = label.dataset.prefectureName || '';
      const visibledStoreCheckboxes = [];
      const storeCheckboxesOfPrefecture = prefectureDiv.querySelectorAll('.store-checkbox');
      storeCheckboxesOfPrefecture.forEach(storeCheckbox => {
        const storeLabel = (storeCheckbox as HTMLElement).parentElement as HTMLElement;
        if (storeLabel.style.display != 'none') {
          visibledStoreCheckboxes.push(checkbox);
        }
      });
      if (visibledStoreCheckboxes.length) {
        // 表示されている店舗がある
        prefectureDiv.style.display = 'block';
        (label.querySelector('.prefecture-name') as HTMLElement).innerText = prefectureName + ' (' + visibledStoreCheckboxes.length + ')';
      } else {
        // 表示されている店舗がない
        prefectureDiv.style.display = 'none';
      }
    });
    refreshBrandDiv();
  }
  const refreshBrandDiv = () => {
    brandCheckboxes.forEach(checkbox => {
      const label = (checkbox as HTMLElement).parentElement as HTMLElement;
      const brandDiv = (label as HTMLElement).parentElement as HTMLElement;
      const brandName = label.dataset.brandName || '';
      const visibledStoreCheckboxes = [];
      const storeCheckboxesOfBrand = brandDiv.querySelectorAll('.store-checkbox');
      storeCheckboxesOfBrand.forEach(storeCheckbox => {
        const storeLabel = (storeCheckbox as HTMLElement).parentElement as HTMLElement;
        if (storeLabel.style.display != 'none') {
          visibledStoreCheckboxes.push(checkbox);
        }
      });
      if (visibledStoreCheckboxes.length) {
        // 表示されている店舗がある
        brandDiv.style.display = 'block';
        (label.querySelector('.brand-name') as HTMLElement).innerText = brandName + ' (' + visibledStoreCheckboxes.length + ')';
      } else {
        // 表示されている店舗がない
        brandDiv.style.display = 'none';
      }
    });
  }

  const initialize = () => {
    refreshStoreCount();
  }

  // 初期化
  initialize();
});
